import React, { useCallback, useEffect, useState } from 'react';
import Form from "react-bootstrap/Form";
import {Button, ButtonGroup, Col, Row} from "react-bootstrap";
import {isMobile, parsePrice} from "../../../../utils/utils";
import {ORIGIN} from "../../../../utils/configs";

function    PricePickerDynamic(props) {

    const {
        currency,
        disabledOptionTitle,
        draw,
        fieldLabel,
        fieldValue,
        interval,
        isOptionDisabled,
        picklistOptions,
        priceChangeCallback,
        setBtnDisabled,
        tradeSide
    } = props;

    const [reloadKey, setReloadKey] = useState(0);
    const [openModal, setOpenModal] = React.useState(false);
    const [activeTimeframe, setActiveTimeframe] = useState(interval);

    useEffect(() => {
        setActiveTimeframe(interval);
    }, [interval]);

    const handlePricePick = useCallback((data) => {
        if (data.pickerField === fieldLabel) {
            const price = parsePrice(data.price);
            priceChangeCallback("" + price);
            setOpenModal(false);
        }
    }, [fieldLabel, priceChangeCallback]);

    useEffect(() => {

        const handleMessage = (event) => {
            switch (event.data?.type) {

                case "pick_price": {
                    handlePricePick(event.data.data);
                    break;
                }

                default: {}
            }
        }

        if (openModal) {
            setBtnDisabled?.(isMobile());
            window.addEventListener('message', handleMessage);
        }
        return () => window.removeEventListener('message', handleMessage);
    }, [handlePricePick, openModal, setBtnDisabled]);

    const chartClick = () => {
        setOpenModal((isOpen) => !isOpen);
    }

    const handleTimeframeChange = (tf) => {
        setActiveTimeframe(tf);
        setReloadKey(reloadKey + 1);
    }

    const getIframe = () => {
        const height = isMobile() ? "420px" : "420px";
        const theme = localStorage.getItem("theme");

        let src = `${ORIGIN}/tvcharts?currency=${currency}&base=USDT&intervals=${activeTimeframe}&mobile=true&insightsApp=true&pickerField=${fieldLabel}&isSpot=false&draw=${draw}&theme=${theme}`;

        return (<iframe
            key={reloadKey}
            title={`${fieldLabel} price picker`}
            src={src}
            width="100%"
            height={height}
            scrolling="no"
            sandbox="
          allow-scripts
          allow-same-origin
          allow-forms
          allow-popups
          allow-popups-to-escape-sandbox
          allow-top-navigation-by-user-activation
          allow-modals"
        ></iframe>)
    }

    return (
        <Row>
            {openModal && (
                <div>
                <ButtonGroup aria-label="Timeframe">
                    {["5M", "15M", "4H", "1D", "1W"].map((tf) => (
                    <Button key={tf} variant={activeTimeframe === tf ? "primary" : "secondary"} onClick={() => handleTimeframeChange(tf)}>
                    {tf}
                    </Button>
                    ))}
                </ButtonGroup>
                {getIframe()}
              </div>)}

            <Col md={12}>
                <Form.Group className="mb-3">
                    <Form.Label>{fieldLabel}</Form.Label>
                    <div className="d-flex gap-2 mb-2">
                        <Form.Control
                            inputMode="decimal"
                            value={fieldValue ?? ""}
                            onChange={(event) => priceChangeCallback(event.target.value)}
                        />
                        <Button variant="outline-primary" onClick={chartClick}>Pick</Button>
                    </div>

                    {picklistOptions && tradeSide && (
                        <div className="d-flex flex-wrap">
                            {(picklistOptions[tradeSide] || []).map((opt) => {
                                const disabled = Boolean(isOptionDisabled?.(opt));
                                return (
                                    <Button
                                        key={opt}
                                        variant={fieldValue === opt ? "primary" : "outline-primary"}
                                        active={fieldValue === opt}
                                        disabled={disabled}
                                        title={disabled ? disabledOptionTitle?.(opt) : undefined}
                                        onClick={() => priceChangeCallback(opt)}
                                        className="me-1 mb-1"
                                        style={disabled ? {opacity: 0.45} : undefined}
                                        size="sm"
                                    >
                                        {opt}
                                    </Button>
                                );
                            })}
                        </div>
                    )}
                </Form.Group>
            </Col>
        </Row>
    );
}

export default PricePickerDynamic;
